import { styled } from '@mui/material'

export const Root = styled('div')`
  padding: 10px 0 0;
  width: 100%;
`

export const Navigation = styled('section')`
  width: 100%;
`
